<template>
    <v-container fluid px-3 pt-3>
        <v-row row wrap>
            <v-col cols="12">
                <h3>Birth Certificate Order</h3>
            </v-col>
        </v-row>
        <v-row row wrap v-if="isCertReturned">
            <v-col cols="12">
                <h5 class="red--text">
                    Your certificate order was returned for further information. You will need to respond to the below message and re-submit your request.
                    If you do not respond, your request for a certificate will be canceled on {{orderStatusExpireDate}}. <span class="font-weight-bold">Any fees already paid for this order cannot be refunded.</span>
                    If this order is canceled, you will need to create a completely new order, although you may use the same Portal account to do so.
                </h5>
            </v-col>
        </v-row>
        <v-row row wrap v-if="mailMessage">
            <v-col cols="12">
                <h5 style="background-color: #FFFF88">{{ mailMessage }}</h5>
            </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row>
            <v-col>
                <v-form v-model="birthForm" ref="form" >
                    <v-container>
                        <v-row align="center">
                            <v-col align-self="center" cols="12">
                                <h3>BIRTH RECORD - Record(s) Requested (${{certCost()}} each)</h3>
                            </v-col>
                            <v-flex xs12 sm6 align-self="center">
                                <v-text-field :disabled="!isCertNew" v-model="numberOfCertificates" @keypress="filterNumbers($event)" type="number" label="(#) Birth Certificate(s)" min="0" max="50" :rules="requiredRule && (numberOfAffidavits >= 1 ? lessThan0Rule : numCertRule)"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-text-field :disabled="!isCertNew" v-model="numberOfAffidavits" @keypress="filterNumbers($event)" type="number" label="(#) Affidavit(s) Acknowledging Paternity" min="0" max="50" :rules="requiredRule && (numberOfCertificates >= 1 ? lessThan0Rule : numCertRule)"></v-text-field>
                            </v-flex>
                        </v-row>
                        <certificate-payment ref="certPaymentRef" :numberOfCertificates="numberOfCertificates" :numberOfAffidavits="numberOfAffidavits" @submit="continueToPayment" @resubmit="redirectToHome"></certificate-payment>
                        <v-row>
                            <v-col align-self="center" cols="12">
                                <h4>Complete information as it appears on the Record</h4>
                            </v-col>
                            <v-divider></v-divider>
                        </v-row>
                        <v-layout rwo wrap>
                            <v-flex xs12 sm4 px-2>
                                <v-text-field :disabled="!canEdit" label="Full First Name" v-model="birthOrder.certFirstName" required :rules="requiredRule"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm4 px-2>
                                <v-text-field :disabled="!canEdit" label="Full Middle Name" v-model="birthOrder.certMiddleName"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm4 px-2>
                                <v-text-field :disabled="!canEdit" label="Full Last Name" v-model="birthOrder.certLastName" required :rules="requiredRule"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <b>If this record could be listed under any other name (due to legal name change or adoption) please list other possible names on record:</b>
                            </v-flex>
                            <v-flex xs12 sm6 px-2>
                                <v-text-field :disabled="!canEdit" label="Other Name(s)" v-model="birthOrder.certOtherNames"></v-text-field>
                            </v-flex>
                            <v-flex xs6 sm3 px-2>
                                <v-text-field :disabled="!canEdit" label="Date of Birth" type="date" v-model="birthOrder.certDob" required :rules="requiredRule"></v-text-field>
                            </v-flex>
                            <v-flex xs6 sm3 px-2>
                                <v-select
                                    label="Place of Birth: City"
                                    v-model="birthOrder.certCity"
                                    :items="cities"
                                    item-text="description"
                                    item-value="id"
                                    :disabled="!canEdit"
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 sm3 px-2 align-self-center class="text-center">
                                OR
                            </v-flex>
                            <v-flex xs12 sm3 px-2>
                                <v-select
                                    label="Place of Birth: County"
                                    v-model="birthOrder.certCounty"
                                    :items="counties"
                                    item-text="description"
                                    item-value="id"
                                    :disabled="!canEdit"
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 sm6 md3 px-2>
                                <v-text-field :disabled="!canEdit" label="Mother/Parent Full First Name" v-model="birthOrder.certMotherFirstName" required :rules="requiredRule"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md3 px-2>
                                <v-text-field :disabled="!canEdit" label="Full Middle Name" v-model="birthOrder.certMotherMiddleName"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md3 px-2>
                                <v-text-field :disabled="!canEdit" label="Full Last Name" v-model="birthOrder.certMotherLastName" required :rules="requiredRule"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md3 px-2>
                                <v-text-field :disabled="!canEdit" label="Full Maiden Name" v-model="birthOrder.certMotherMaidenName"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md3 px-2>
                                <v-text-field :disabled="!canEdit" label="Father/Parent Full First Name" v-model="birthOrder.certOtherFirstName" required :rules="requiredRule"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md3 px-2>
                                <v-text-field :disabled="!canEdit" label="Full Middle Name" v-model="birthOrder.certOtherMiddleName"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md3 px-2>
                                <v-text-field :disabled="!canEdit" label="Full Last Name" v-model="birthOrder.certOtherLastName" required :rules="requiredRule"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6 md3 px-2>
                                <v-text-field :disabled="!canEdit" label="Full Maiden Name" v-model="birthOrder.certOtherMaidenName"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <h4>Requestors Information</h4>
                            </v-flex>
                            <v-flex xs12 sm4 px-2>
                                <v-text-field :disabled="!canEdit" label="Full First Name" v-model="birthOrder.reqFirstName" required :rules="requiredRule"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm4 px-2>
                                <v-text-field :disabled="!canEdit" label="Full Middle Name" v-model="birthOrder.reqMiddleName"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm4 px-2>
                                <v-text-field :disabled="!canEdit" label="Full Last Name (Exactly as shown on drivers license)" v-model="birthOrder.reqLastName" required :rules="requiredRule"></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <addr :disabled="!canEdit" id="mailingAddress" :isRequired="true" customAddressLabelPrepend="Mailing " ref="mailingAddressRef"></addr>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12 sm5 px-2>
                                <v-text-field :disabled="!canEdit" label="Contact Phone Number" v-model="birthOrder.phone" type="tel" v-mask="phoneMask"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm2 align-self-center class="text-center">
                                AND/OR
                            </v-flex>
                            <v-flex xs12 sm5 px-2>
                                <v-text-field :disabled="!canEdit" label="Contact Email Address" v-model="birthOrder.email"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <b>State your relationship to the person(s) named on the certificate(s) requested, or enter Self:</b>
                            </v-flex>
                            <v-flex xs12 sm6 px-2>
                                <v-text-field :disabled="!canEdit" label="Relationship" v-model="birthOrder.relationship"></v-text-field>
                            </v-flex>
                            <v-flex xs12 px-2>
                                <v-text-field :disabled="!canEdit" label="Purpose for requesting certificate" v-model="birthOrder.purpose" required :rules="requiredRule" counter="500" maxlength="500"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-row>
                            <v-col cols="12">
                                <b>
                                    ATTACH IMAGE OF A VALID GOVERNMENT ISSUED ID HERE<br />
                                    (Driver’s License, State ID Card, Passport, Tribal ID)<br />
                                    *If signature is located on the back, provide images of both sides
                                </b>
                            </v-col>
                        </v-row>
                        <imageList ref="imageListRef" :disabled="!canEdit" @send-message="saveUnfinished()"></imageList>
                        <v-layout row wrap>
                            <v-flex xs12 md3 align-self-center>
                                <b>Please Enter Full Name (Must be 18 or older):</b>
                            </v-flex>
                            <v-flex xs10 md7 px-2>
                                <v-text-field :disabled="!canEdit" label="Full Name" v-model="birthOrder.signature" required :rules="requiredRule"></v-text-field>
                            </v-flex>
                            <v-flex xs2 md2 px-2>
                                <v-text-field :disabled="true" validate-on-blur type="date" label="Date" v-model="birthOrder.date"></v-text-field>
                            </v-flex>
                            <v-flex xs12 md10 align-self-center v-if="canEdit">
                                I certify the information provided for this certificate is correct to the best of my knowledge and belief.
                                I also acknowledge that submitting this form constitutes an electronic signature and will be considered as a handwritten signature for all purposes and shall have the same force and effect as a handwritten signature.
                            </v-flex>
                            <v-flex xs12 md2 px-3 align-self-center v-if="canEdit">
                                <v-checkbox required :rules="requiredRule"></v-checkbox>
                            </v-flex>
                        </v-layout>

                        <br>

                        <v-layout v-if="(isExcessOrder && canEdit) || (isExcessOrderVssRequest && canEdit)" row wrap>
                            <v-flex xs12>
                                <certificate-excess-order-form :canEdit="canEdit" :excessAckProp="birthOrder.excessAck" ref="excessOrderRef" @data="getExcessOrderData" :isVssRequest="isExcessOrderVssRequest" />
                            </v-flex>
                        </v-layout>

                        <br>

                        <v-row v-if="errors.length > 0">
                            <v-col cols="12">
                                Please Correct the Following Errors:
                                <ul>
                                    <li class="red--text" v-for="error in errors" :key="error">
                                        {{error}}
                                    </li>
                                </ul>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" v-if="isSaved">
                                Your Order has been saved. To continue work on it find it in your inbox. The ID for this order is {{birthOrder.portalBirthOrderId}}.
                            </v-col>
                            <v-col cols="12" v-if="isSubmitted">
                                Your Order has been submitted. Once it has been approved or denied you will see it in your inbox. The ID for this order is {{birthOrder.portalBirthOrderId}}.
                            </v-col>
                        </v-row>
                        <v-layout row wrap v-if="canEdit">
                            <v-flex xs12 sm3 md2 lg2 xl2>
                                <v-btn @click="submit()" :disabled="!birthForm || isLoading || isSubmitted" color="secondary">SUBMIT</v-btn>
                            </v-flex>
                            <v-flex xs12 sm6 md8 lg8 xl8 v-if="canEdit && !isCertNew" style="margin-top: -27px">
                                <contact-vss ref="responseContactVss" :operationType="operationType" :subOperationType="responseContactOperation" :requestId="birthOrder.portalBirthOrderId" :modType="10"></contact-vss>
                            </v-flex>
                            <v-flex xs12 sm3 md2 lg2 xl2>
                                <v-btn @click="saveUnfinished()" :disabled="isLoading || isSubmitted" color="secondary">SAVE UNFINISHED</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
            </v-col>
        </v-row>
        <contact-vss :operationType="operationType" :requestId="birthOrder.portalBirthOrderId" :modType="10"></contact-vss>
    </v-container>
</template>

<script>
import Addr from '@/components/Address'
import ImageList from '@/components/CertificateImages'
import CertificatePayment from '@/components/CertificatePayment'
import certService from '@/services/certificateService'
import lookupService from '@/services/lookupService'
import mailService from '@/services/mailService'
import ContactVss from '../components/ContactVss.vue'
import { mask } from 'vue-the-mask'
import CertificateExcessOrderForm from '../components/certificates/CertificateExcessOrderForm.vue'

export default {
    components: {
        Addr,
        ImageList,
        CertificatePayment,
        ContactVss,
        CertificateExcessOrderForm
    },
    directives: {
        mask
    },
    data: () => {
        return {
            testData: {},
            cities: [],
            counties: [],
            errors: [],
            phoneMask: '###-###-####',
            birthForm: false,
            affCost: null,
            requiredRule: [v => !!v || 'Required'],
            numCertRule: [v => v >= 1 || 'Cannot be less than 1', v => v <= 50 || 'Cannot be more than 50'],
            lessThan0Rule: [v => v >= 0 || 'Cannot be less than 0', v => v <= 50 || 'Cannot be more than 50'],
            //dateRule: [v => !!v || 'Required', v => v == new Date().toISOString().split('T')[0] || 'Must Match Today\'s Date'],
            isLoading: false,
            isSubmitted: false,
            paymentId: null,
            isSaved: false,
            images: null,
            savedImages: null,
            subtotalData: 0,
            subtotalCert: 0,
            subtotalAff: 0,
            prettySubtotal: null,
            prettyProcessingFee: null,
            prettyTotal: null,
            deleteSavedImages: false,
            numberOfCertificates: 1,
            numberOfAffidavits: 0,
            birthOrder: {
                portalBirthOrderId: null,
                numCerts: 0,
                numAffidavits: 0,
                certFirstName: null,
                certMiddleName: null,
                certLastName: null,
                certOtherNames: null,
                certDob: null,
                certCity: null,
                certCounty: null,
                certMotherFirstName: null,
                certMotherMiddleName: null,
                certMotherLastName: null,
                certMotherMaidenName: null,
                certOtherFirstName: null,
                certOtherMiddleName: null,
                certOtherLastName: null,
                certOtherMaidenName: null,
                reqFirstName: null,
                reqMiddleName: null,
                reqLastName: null,
                mailingAddress: {},
                phone: null,
                email: null,
                relationship: null,
                purpose: null,
                signature: null,
                date: null,
                isCompleted: false,
                excessOrderAck: {}
            },
            orderStatus: null,
            orderStatusExpireDate: null,
            mailMessage: null,
            operationType: mailService.OperationEnum.CertificateOrder,
            responseContactOperation: mailService.SubOperationEnum.ResponseContact,
            messageReasons: []
        }
    },
    mounted () {
        window.scrollTo(0, 0)
        lookupService.GetWyomingCities(this.$http).then(response => {
            this.cities = response.data
        })
        lookupService.GetWyomingCounties(this.$http).then(response => {
            this.counties = response.data
        })

        this.$refs.certPaymentRef.setup('10')

        if (this.$route.query.orderId) {
            certService.getBirthOrderById(this.$http, this.$route.query.orderId).then(response => {
                if (response.data) {
                    this.setupOrder(response.data)
                    this.$refs.imageListRef.loadImages('10', this.birthOrder.portalBirthOrderId)
                }
            })
            lookupService.GetPortalMessageReasons(this.$http, 10, this.$route.query.orderId).then(response => {
                this.messageReasons = response.data
            })
            this.loadMailMessage()
        }

        this.birthOrder.date = this.dateToYYYYMMDD(new Date())
    },
    computed: {
        isCertNew () {
            return this.orderStatus === certService.CertificateStatusEnum.New || this.orderStatus === null
        },
        canEdit () {
            switch (this.orderStatus) {
            case null:
            case certService.CertificateStatusEnum.New:
            case certService.CertificateStatusEnum.MoreInformationRequested:
                return true
            default:
                return false
            }
        },
        isCertReturned () {
            return this.orderStatus === certService.CertificateStatusEnum.MoreInformationRequested
        },
        isExcessOrder () {
            return this.numberOfCertificates > 3
        },
        isExcessOrderVssRequest () {
            return this.messageReasons.some(e => e.portalMessageReasonTypeId === lookupService.MessageReasonTypeEnum.ExcessiveCopies)
        }
    },
    methods: {
        loadMailMessage () {
            mailService.GetMailByRequestId(this.$http, this.$route.query.orderId).then(res => {
                if (res.data && res.data.length > 0) {
                    this.mailMessage = res.data[res.data.length - 1].message
                }
            })
        },
        submit () {
            if (!confirm('Proceed to order payment. Once your order and payment are submitted you will be unable to make any changes. Do you want to proceed?')) { return }

            this.isLoading = true
            this.errors = []

            this.birthOrder.numCerts = parseInt(this.numberOfCertificates) || 0
            this.birthOrder.numAffidavits = parseInt(this.numberOfAffidavits) || 0

            if (this.birthOrder.numCerts < 1 && this.birthOrder.numAffidavits < 1) {
                this.errors.push('Number of Certificates and/or Affidavits is Required')
            }
            if (this.birthOrder.numCerts > 50 || this.birthOrder.numAffidavits > 50) {
                this.errors.push('Cannot request more than 50 Certificates and/or Affidavits')
            }
            if (!this.birthOrder.certCity && !this.birthOrder.certCounty) {
                this.errors.push('Either Birth City or Birth County Must be Provided')
            }
            if (!this.birthOrder.phone && !this.birthOrder.email) {
                this.errors.push('Either a Contact Phone Number or Contact Email Address Must be Provided')
            }
            if (this.$refs.mailingAddressRef.checkFields()) {
                this.errors.push('Mailing address is Required')
            }
            if (this.$refs.imageListRef.mediaList.length === 0) {
                this.errors.push('At Least One Image is Required')
            }

            if ((this.birthOrder.numCerts > 3 || this.messageReasons.some(e => e.portalMessageReasonTypeId === lookupService.MessageReasonTypeEnum.ExcessiveCopies)) && !this.$refs.excessOrderRef.validate()) {
                this.errors.push('Excess Order Acknowledgement is Required')
            }

            if (this.birthForm && this.errors.length === 0) {
                this.birthOrder.mailingAddress = this.$refs.mailingAddressRef.placeDTO
                if ((this.birthOrder.numCerts > 3 || this.messageReasons.some(e => e.portalMessageReasonTypeId === lookupService.MessageReasonTypeEnum.ExcessiveCopies))) {
                    this.$refs.excessOrderRef.getData()
                }
                this.birthOrder.mailingAddress.county = (this.birthOrder.mailingAddress.county || '').replace(' County', '')
                this.birthOrder.isCompleted = true
                this.birthOrder.date = this.dateToYYYYMMDD(new Date())
                certService.sendBirthCertOrder(this.$http, this.birthOrder).then(response => {
                    if (response.data) {
                        let validationResult = response.data.validationResult
                        this.birthOrder.portalBirthOrderId = response.data.portalBirthOrderId
                        this.addOrderIdToRoute(this.birthOrder.portalBirthOrderId)
                        this.isSaved = true
                        if (validationResult.isValid) {
                            if (this.$refs.responseContactVss) this.$refs.responseContactVss.sendMessage()
                            this.$refs.certPaymentRef.submit(this.birthOrder.portalBirthOrderId)
                        } else {
                            this.errors = validationResult.errorMessages
                        }
                    } else {
                        alert('Unexpected error occurred, please sumbit your order again.')
                    }
                    this.isLoading = false
                })
            } else {
                this.isLoading = false
            }
        },
        saveUnfinished () {
            this.isLoading = true
            this.birthOrder.isCompleted = false
            this.birthOrder.date = null
            this.birthOrder.numCerts = parseInt(this.numberOfCertificates) || 0
            this.birthOrder.numAffidavits = parseInt(this.numberOfAffidavits) || 0
            this.birthOrder.mailingAddress = this.$refs.mailingAddressRef.placeDTO
            this.birthOrder.mailingAddress.county = (this.birthOrder.mailingAddress.county || '').replace(' County', '')
            if ((this.birthOrder.numCerts > 3 || this.messageReasons.some(e => e.portalMessageReasonTypeId === lookupService.MessageReasonTypeEnum.ExcessiveCopies))) {
                this.$refs.excessOrderRef.getData()
            }
            certService.sendBirthCertOrder(this.$http, this.birthOrder).then(response => {
                if (response.data) {
                    this.birthOrder.portalBirthOrderId = response.data.portalBirthOrderId
                    this.addOrderIdToRoute(this.birthOrder.portalBirthOrderId)
                    this.isSaved = true
                    this.birthOrder.date = this.dateToYYYYMMDD(new Date())
                    this.$refs.imageListRef.uploadImage(this.birthOrder.portalBirthOrderId, '10')
                } else {
                    alert('Unexpected error occurred, please try again.')
                }
                this.isLoading = false
            })
        },
        setupOrder (dto) {
            this.birthOrder = dto
            this.birthOrder.certDob = dto.certDob != null ? this.dateToYYYYMMDD(new Date(dto.certDob)) : dto.certDob
            this.$refs.mailingAddressRef.placeDTO = dto.mailingAddress
            this.numberOfCertificates = dto.numCerts
            this.numberOfAffidavits = dto.numAffidavits
            this.birthOrder.date = this.dateToYYYYMMDD(new Date())
            this.birthOrder.portalBirthOrderId = dto.portalBirthOrderId
            this.$refs.form.validate()
            this.certStatus()
        },
        dateToYYYYMMDD (d) {
            return new Date(d.getTime() - (d.getTimezoneOffset() * 60 * 1000)).toISOString().split('T')[0]
        },
        continueToPayment (paymentId) {
            this.$router.push('payment-processing/' + paymentId)
        },
        redirectToHome () {
            this.$router.push('order-certificate')
        },
        certCost: function () {
            if (this.$refs.certPaymentRef) {
                return this.$refs.certPaymentRef.certCost
            } else {
                return null
            }
        },
        certStatus () {
            certService.getOrderStatus(this.$http, this.birthOrder.portalBirthOrderId, lookupService.ModuleTypeEnum.Birth).then(res => {
                if (res.data) {
                    this.orderStatus = res.data.orderStatusId
                    this.orderStatusExpireDate = res.data.orderStatusExpireDate
                }
            })
        },
        getExcessOrderData (data) {
            this.birthOrder.excessOrderAck = data
        },
        filterNumbers (evt) {
            evt = evt || window.event
            let expect = evt.target.value.toString() + evt.key.toString()
            if (!/^[0-9]*$/.test(expect)) {
                evt.preventDefault()
            } else {
                return true
            }
        },
        addOrderIdToRoute (id) {
            if (!this.$route.query.orderId) {
                this.$router.replace('/order-birth-certificate?orderId=' + id)
            }
        }
    }
}
</script>
